/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FormSignProcess } from '../models/form-sign-process';
import { FormSignProcessPartial } from '../models/form-sign-process-partial';
import { FormSignProcessWithRelations } from '../models/form-sign-process-with-relations';
import { NewFormSignProcess } from '../models/new-form-sign-process';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({
  providedIn: 'root',
})
export class FormSignProcessControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation formSignProcessControllerAnewAssign
   */
  static readonly FormSignProcessControllerAnewAssignPath = '/form-sign-processes/anewAssign';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `anewAssign()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  anewAssign$Response(params?: {
    context?: HttpContext
    body?: {
}
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, FormSignProcessControllerService.FormSignProcessControllerAnewAssignPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `anewAssign$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  anewAssign(params?: {
    context?: HttpContext
    body?: {
}
  }
): Observable<{
}> {

    return this.anewAssign$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation formSignProcessControllerAssistantCancelForm
   */
  static readonly FormSignProcessControllerAssistantCancelFormPath = '/form-sign-processes/assistantCancelForm';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assistantCancelForm()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assistantCancelForm$Response(params?: {
    signMan?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, FormSignProcessControllerService.FormSignProcessControllerAssistantCancelFormPath, 'post');
    if (params) {
      rb.query('signMan', params.signMan, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `assistantCancelForm$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assistantCancelForm(params?: {
    signMan?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<{
}> {

    return this.assistantCancelForm$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation formSignProcessControllerCount
   */
  static readonly FormSignProcessControllerCountPath = '/form-sign-processes/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, FormSignProcessControllerService.FormSignProcessControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
    context?: HttpContext
  }
): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation formSignProcessControllerSendAssistantInquiry
   */
  static readonly FormSignProcessControllerSendAssistantInquiryPath = '/form-sign-processes/sendAssistantInquiry';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendAssistantInquiry()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  sendAssistantInquiry$Response(params: {
    signMan?: string;
    context?: HttpContext

    /**
     * multipart/form-data value.
     */
    body: {
}
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, FormSignProcessControllerService.FormSignProcessControllerSendAssistantInquiryPath, 'post');
    if (params) {
      rb.query('signMan', params.signMan, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendAssistantInquiry$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  sendAssistantInquiry(params: {
    signMan?: string;
    context?: HttpContext

    /**
     * multipart/form-data value.
     */
    body: {
}
  }
): Observable<{
}> {

    return this.sendAssistantInquiry$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation formSignProcessControllerSendBudgetAaudit
   */
  static readonly FormSignProcessControllerSendBudgetAauditPath = '/form-sign-processes/sendBudgetAaudit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendBudgetAaudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendBudgetAaudit$Response(params?: {
    signMan?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, FormSignProcessControllerService.FormSignProcessControllerSendBudgetAauditPath, 'post');
    if (params) {
      rb.query('signMan', params.signMan, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendBudgetAaudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendBudgetAaudit(params?: {
    signMan?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<{
}> {

    return this.sendBudgetAaudit$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation formSignProcessControllerSendBudgetAauditStone
   */
  static readonly FormSignProcessControllerSendBudgetAauditStonePath = '/form-sign-processes/sendBudgetAauditStone';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendBudgetAauditStone()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendBudgetAauditStone$Response(params?: {
    signMan?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, FormSignProcessControllerService.FormSignProcessControllerSendBudgetAauditStonePath, 'post');
    if (params) {
      rb.query('signMan', params.signMan, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendBudgetAauditStone$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendBudgetAauditStone(params?: {
    signMan?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<{
}> {

    return this.sendBudgetAauditStone$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation formSignProcessControllerSendBudgetAauditStoneTry
   */
  static readonly FormSignProcessControllerSendBudgetAauditStoneTryPath = '/form-sign-processes/sendBudgetAauditStoneTry';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendBudgetAauditStoneTry()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendBudgetAauditStoneTry$Response(params?: {
    signMan?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, FormSignProcessControllerService.FormSignProcessControllerSendBudgetAauditStoneTryPath, 'post');
    if (params) {
      rb.query('signMan', params.signMan, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendBudgetAauditStoneTry$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendBudgetAauditStoneTry(params?: {
    signMan?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<{
}> {

    return this.sendBudgetAauditStoneTry$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation formSignProcessControllerSendSignResultFive
   */
  static readonly FormSignProcessControllerSendSignResultFivePath = '/form-sign-processes/sendSignResultFive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendSignResultFive()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendSignResultFive$Response(params?: {
    signMan?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, FormSignProcessControllerService.FormSignProcessControllerSendSignResultFivePath, 'post');
    if (params) {
      rb.query('signMan', params.signMan, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendSignResultFive$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendSignResultFive(params?: {
    signMan?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<{
}> {

    return this.sendSignResultFive$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation formSignProcessControllerSendSignResultFour
   */
  static readonly FormSignProcessControllerSendSignResultFourPath = '/form-sign-processes/sendSignResultFour';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendSignResultFour()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendSignResultFour$Response(params?: {
    signMan?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, FormSignProcessControllerService.FormSignProcessControllerSendSignResultFourPath, 'post');
    if (params) {
      rb.query('signMan', params.signMan, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendSignResultFour$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendSignResultFour(params?: {
    signMan?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<{
}> {

    return this.sendSignResultFour$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation formSignProcessControllerSendSignResultSeven
   */
  static readonly FormSignProcessControllerSendSignResultSevenPath = '/form-sign-processes/sendSignResultSeven';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendSignResultSeven()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendSignResultSeven$Response(params?: {
    signMan?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, FormSignProcessControllerService.FormSignProcessControllerSendSignResultSevenPath, 'post');
    if (params) {
      rb.query('signMan', params.signMan, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendSignResultSeven$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendSignResultSeven(params?: {
    signMan?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<{
}> {

    return this.sendSignResultSeven$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation formSignProcessControllerSendSignResultSix
   */
  static readonly FormSignProcessControllerSendSignResultSixPath = '/form-sign-processes/sendSignResultSix';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendSignResultSix()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendSignResultSix$Response(params?: {
    signMan?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, FormSignProcessControllerService.FormSignProcessControllerSendSignResultSixPath, 'post');
    if (params) {
      rb.query('signMan', params.signMan, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendSignResultSix$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendSignResultSix(params?: {
    signMan?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<{
}> {

    return this.sendSignResultSix$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation formSignProcessControllerSendSignResultSixRe
   */
  static readonly FormSignProcessControllerSendSignResultSixRePath = '/form-sign-processes/sendSignResultSixRe';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendSignResultSixRe()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendSignResultSixRe$Response(params?: {
    signMan?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, FormSignProcessControllerService.FormSignProcessControllerSendSignResultSixRePath, 'post');
    if (params) {
      rb.query('signMan', params.signMan, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendSignResultSixRe$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendSignResultSixRe(params?: {
    signMan?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<{
}> {

    return this.sendSignResultSixRe$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation formSignProcessControllerSendSignResultStep3
   */
  static readonly FormSignProcessControllerSendSignResultStep3Path = '/form-sign-processes/sendSignResultStep3';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendSignResultStep3()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendSignResultStep3$Response(params?: {
    signMan?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, FormSignProcessControllerService.FormSignProcessControllerSendSignResultStep3Path, 'post');
    if (params) {
      rb.query('signMan', params.signMan, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendSignResultStep3$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendSignResultStep3(params?: {
    signMan?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<{
}> {

    return this.sendSignResultStep3$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation formSignProcessControllerSignByMinisterial
   */
  static readonly FormSignProcessControllerSignByMinisterialPath = '/form-sign-processes/signByMinisterial/{module}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `signByMinisterial()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  signByMinisterial$Response(params: {
    signMan?: string;
    module: string;
    context?: HttpContext
    body?: NewFormSignProcess
  }
): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, FormSignProcessControllerService.FormSignProcessControllerSignByMinisterialPath, 'post');
    if (params) {
      rb.query('signMan', params.signMan, {});
      rb.path('module', params.module, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `signByMinisterial$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  signByMinisterial(params: {
    signMan?: string;
    module: string;
    context?: HttpContext
    body?: NewFormSignProcess
  }
): Observable<any> {

    return this.signByMinisterial$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation formSignProcessControllerUpdateSignStatus
   */
  static readonly FormSignProcessControllerUpdateSignStatusPath = '/form-sign-processes/updateSignStatus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSignStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSignStatus$Response(params?: {
    context?: HttpContext
    body?: {
}
  }
): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, FormSignProcessControllerService.FormSignProcessControllerUpdateSignStatusPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateSignStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSignStatus(params?: {
    context?: HttpContext
    body?: {
}
  }
): Observable<any> {

    return this.updateSignStatus$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation formSignProcessControllerFindById
   */
  static readonly FormSignProcessControllerFindByIdPath = '/form-sign-processes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: number;
    filter?: any;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<FormSignProcessWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, FormSignProcessControllerService.FormSignProcessControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FormSignProcessWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: number;
    filter?: any;
    context?: HttpContext
  }
): Observable<FormSignProcessWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<FormSignProcessWithRelations>) => r.body as FormSignProcessWithRelations)
    );
  }

  /**
   * Path part for operation formSignProcessControllerReplaceById
   */
  static readonly FormSignProcessControllerReplaceByIdPath = '/form-sign-processes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `replaceById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  replaceById$Response(params: {
    id: number;
    context?: HttpContext
    body?: FormSignProcess
  }
): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, FormSignProcessControllerService.FormSignProcessControllerReplaceByIdPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `replaceById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  replaceById(params: {
    id: number;
    context?: HttpContext
    body?: FormSignProcess
  }
): Observable<any> {

    return this.replaceById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation formSignProcessControllerDeleteById
   */
  static readonly FormSignProcessControllerDeleteByIdPath = '/form-sign-processes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, FormSignProcessControllerService.FormSignProcessControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: number;
    context?: HttpContext
  }
): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation formSignProcessControllerUpdateById
   */
  static readonly FormSignProcessControllerUpdateByIdPath = '/form-sign-processes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: number;
    context?: HttpContext
    body?: FormSignProcessPartial
  }
): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, FormSignProcessControllerService.FormSignProcessControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: number;
    context?: HttpContext
    body?: FormSignProcessPartial
  }
): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation formSignProcessControllerFind
   */
  static readonly FormSignProcessControllerFindPath = '/form-sign-processes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<FormSignProcessWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, FormSignProcessControllerService.FormSignProcessControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FormSignProcessWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
    context?: HttpContext
  }
): Observable<Array<FormSignProcessWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<FormSignProcessWithRelations>>) => r.body as Array<FormSignProcessWithRelations>)
    );
  }

  /**
   * Path part for operation formSignProcessControllerCreate
   */
  static readonly FormSignProcessControllerCreatePath = '/form-sign-processes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    context?: HttpContext
    body?: NewFormSignProcess
  }
): Observable<StrictHttpResponse<FormSignProcess>> {

    const rb = new RequestBuilder(this.rootUrl, FormSignProcessControllerService.FormSignProcessControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FormSignProcess>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    context?: HttpContext
    body?: NewFormSignProcess
  }
): Observable<FormSignProcess> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<FormSignProcess>) => r.body as FormSignProcess)
    );
  }

  /**
   * Path part for operation formSignProcessControllerUpdateAll
   */
  static readonly FormSignProcessControllerUpdateAllPath = '/form-sign-processes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAll()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAll$Response(params?: {
    where?: any;
    context?: HttpContext
    body?: FormSignProcessPartial
  }
): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, FormSignProcessControllerService.FormSignProcessControllerUpdateAllPath, 'patch');
    if (params) {
      rb.query('where', params.where, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateAll$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAll(params?: {
    where?: any;
    context?: HttpContext
    body?: FormSignProcessPartial
  }
): Observable<LoopbackCount> {

    return this.updateAll$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation formSignProcessControllerGetVendorInfo
   */
  static readonly FormSignProcessControllerGetVendorInfoPath = '/form-sign-processess/getVendorInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVendorInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVendorInfo$Response(params?: {
    formId?: string;
    version?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, FormSignProcessControllerService.FormSignProcessControllerGetVendorInfoPath, 'get');
    if (params) {
      rb.query('formId', params.formId, {});
      rb.query('version', params.version, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getVendorInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVendorInfo(params?: {
    formId?: string;
    version?: string;
    context?: HttpContext
  }
): Observable<{
}> {

    return this.getVendorInfo$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

}
